import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-geometry-column',
    templateUrl: './geometry-column.component.html',
    styleUrls: ['./geometry-column.component.scss'],
    standalone: false
})
export class GeometryColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }
}
